import {types} from "mobx-state-tree";


export function create(item) {
  return DataDeliveryType.create({
    uuid: item?.type,
    type: item?.type,
    label: item?.label,
    version: item?.version,
    schema: JSON.stringify(item?.schema),
    uiSchema: JSON.stringify(item?.uiSchema)
  });
}

export const DataDeliveryType = types.model('DataDeliveryType', {
  uuid: types.identifier,
  type: types.string,
  label: types.string,
  version: types.number,
  schema: types.optional(types.string, ""),
  uiSchema: types.optional(types.string, "")

})
